/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelObjection.ts                     *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/crm/objection";

export class AutogenModelObjection<RowType extends ModelRow> extends Endpoint<RowType, RowObjectionFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowObjection extends ModelRow<RowObjectionFields> {
	constructor(values?: Partial<RowObjectionFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowObjectionFields {
	company_id: string;
	descr: string;
	id: string;
	response_script: string;
	type_of: string;
}

